<template>
  <div>
    <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
      Attachments
      <template v-if="editable">
        <button
          class="inline hover:underline text-blue-600 focus:outline-none"
          @click="addAttachment"
        >
          add
        </button>
      </template>
    </h5>

    <div v-if="uploadFormVisible" class="shadow-lg rounded mb-4">
      <div class="shadow-xs rounded bg-gray-100 p-4">
        <UploadForm
          :production-order-item-id="productionOrderItemId"
          @uploaded="commitUpload"
          @upload:completed="hideUploadForm"
          @cancel="hideUploadForm"
        />
      </div>
    </div>

    <div class="mt-2 divide-y rounded-lg border overflow-hidden">
      <div v-for="(attachment, idx) in attachments" :key="attachment.id || idx">
        <div class="px-4 py-3">
          <a
            :href="attachment.url"
            target="_blank"
            class="text-blue-600 text-sm hover:underline"
            v-text="attachment.name"
          />
          <div v-if="editable" class="mt-4 space-x-2">
            <button
              class="inline hover:underline text-blue-600 text-sm focus:outline-none"
              @click="removeAttachment(attachment)"
            >
              remove
            </button>
          </div>
        </div>
      </div>
      <div v-if="attachments.length === 0" class="px-4 py-3 text-sm">
        There are no Attachments.
        <template v-if="editable">
          <button
            class="inline hover:underline text-blue-600 focus:outline-none"
            @click="addAttachment"
          >
            Add an attachment.
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import UploadForm from './relatedAttachments/UploadForm.vue';

export default {
  name: 'RelatedAttachments',

  components: {
    UploadForm,
  },

  props: {
    editable: Boolean,
    productionOrderItemId: {
      type: String,
      required: true,
    },
    attachments: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      uploadFormVisible: false,
    };
  },

  methods: {
    addAttachment() {
      this.uploadFormVisible = true;
    },
    commitUpload(id) {
      const media = this.$store.state.entities.media.byId[id];

      if (!media) {
        return;
      }

      this.$emit('update:attachments', [...this.attachments, JSON.parse(JSON.stringify(media))]);
    },
    hideUploadForm() {
      this.uploadFormVisible = false;
    },
    removeAttachment(removeAttachment) {
      this.$emit('update:attachments', [
        ...this.attachments.filter((attachment) => attachment.id !== removeAttachment.id),
      ]);
    },
  },
};
</script>
